var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-end message_user animate slideInUp"},[_c('div',{staticClass:"message-box_user",style:(_vm.data && _vm.data.key == 'email' ? 'text-transform: lowercase !important;' : ''),domProps:{"innerHTML":_vm._s(_vm.chatResponse)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }